
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">           
            <commitment-edit-win *ngSwitchCase="true"></commitment-edit-win>
            <commitment-details *ngSwitchCase="false"></commitment-details>
        </div>
    </ng-template>  
</main-form-modal>